import { E2E_USER_AGENT } from 'e2e-tests/constants/user-agent';

export function isTestingUserAgent(userAgent: string): boolean {
  // test if the current user agent contains E2E testing
  return Boolean(userAgent && userAgent.includes(E2E_USER_AGENT));
}
